import { initialTasksState, ITasksState } from '../state/tasks.state';
import { TasksAction, ETasksActions } from '../actions/tasks.action';


export function tasksReducers(state = initialTasksState, action: TasksAction): ITasksState {
    switch (action.type) {

        case ETasksActions.GetTasksDetails: {
            return {
                ...state,
                getTasksDetails: action.payload,
                getTasksErrorMessage: null
            };
        }
        case ETasksActions.SetTasksSuccess: {
            const success = {
                data : action.payload,
                from : action.from
            }
            return {
                ...state,
                getTasksSuccessMessage: success,
                getTasksErrorMessage: null
            };
        }
        case ETasksActions.SetTasksError: {
            const error = {
                data : action.payload,
                from : action.from
            }
            return {
                ...state,
                getTasksErrorMessage: error,
                getTasksDetails: null
            };
        }
        case ETasksActions.GetAddTaskForSubUserSuccess: {
            return {
                ...state,
               getAddTaskForSubUserSuccess: action.payload,
               getAddTaskForSubUserError: null
            };
        }
        case ETasksActions.GetAddTaskForSubUserError: {
            return {
                ...state,
                getAddTaskForSubUserError: action.payload,
                getAddTaskForSubUserSuccess: null
            };
        }
        
        default: {   
            return state;
          }
    }

}